/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import {
  PlaybackAutoSeekMode,
  PlaybackFastForwardMode,
  PlaybackRepeatedMode,
  PlaybackRewindMode,
} from '@quickplay/player-interface';

/**
 * Represents [YospaceAdsPlayer]'s initialization data.
 */
export interface YospaceInitializationData {
  /**
   * The url of the content to play.
   */
  contentURL: string;
  /**
   * One of [Session.PlaybackMode] values.
   */
  playbackMode: any;
  /**
   * The user agent to use when firing Yospace analytic tracking Beacons.
   */
  userAgent?: string;
  /**
   * This property concerns the behaviour of firing tracking URLs only.
   * If not set (default), the SDK uses fetch in 'no-cors' mode, which allows only a limited set of request headers (excludes UA and any custom-defined headers).
   * If set, the SDK assumes that the server allows CORS and therefore, if the userAgent property is set then the SDK will use 'cors' mode in the fetch request.
   */
  allowCorsForAnalytics?: boolean;
  /**
   * Sets the read timeout to use when attempting to establish an HTTP connection. This timeout includes the connect timeout and read timeout combined.
   */
  timeout?: number;
  /**
   * Ads playback fast forward mode.
   */
  fastForwardMode?: PlaybackFastForwardMode;
  /**
   * Ads playback rewind mode.
   */
  rewindMode?: PlaybackRewindMode;
  /**
   * Ads playback auto seek mode.
   */
  autoSeekMode?: PlaybackAutoSeekMode;
  /**
   * Ads playback repeat mode.
   */
  repeatMode?: PlaybackRepeatedMode;
}

/**
 * Represents [YospaceAdsPlayer]'s Session State.
 */

export enum Status {
  SUCCESS = 'success',
  FALLBACK = 'fallback',
  ERROR = 'error',
}
